import { Col, Form, Input, Row } from "antd";
import React from "react";

interface NameProps {
  visible: boolean;
}

const Name: React.FC<NameProps> = ({ visible }) => {
  return (
    <Form.Item
      name="name"
      rules={[{ required: true, message: "" }]}
      label={"Name"}
      className="my_account_form_item"
    >
      <Input disabled={!visible} />
    </Form.Item>
  );
};

export default Name;
